module.exports = __webpack_public_path__ + "36a9bb539a51cb94889d0d249deec8f4.svg";